// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9j-0";
export var optionCard = "_9j-1";